<template>
  <b-img
    class="brand-logo"
    :class="{ 'brand-logo--flealover': isGlobalApp }"
    :src="isGlobalApp ? require('@base/assets/images/flealover-sitelogo.png') : require('@base/assets/images/sitelogo.png')"
    :alt="appName"
  />
</template>

<script>
  import { APP_NAME, IS_GLOBAL_APP } from '@base/configs'

  export default {
    name: 'BrandLogo',

    data () {
      return {
        appName: APP_NAME,
        isGlobalApp: IS_GLOBAL_APP,
      }
    },
  }
</script>

<style scoped>
  .brand-logo {
    height: 88px;
    width: auto;
  }

  .brand-logo--flealover {
    height: 64px;
  }
</style>
